// Mock data for Bramador Services Landing Page

export const companyInfo = {
  name: "Bramador",
  tagline: "Servicios Profesionales en la Región",
  description: "Comprometidos con la calidad, centrados en el cliente y enfocados en entregar soluciones confiables con profesionalismo y responsabilidad.",
  phone: "+56956500328",
  email: "contacto@bramador.cl",
  salesEmail: "ventas@bramador.cl",
  whatsapp: "https://wa.me/56956500328",
  founded: "Abril 2020"
};

export const aboutUs = {
  title: "Sobre Nosotros",
  content: [
    "Bramador nace en abril de 2020 en plena pandemia, con el objetivo de entregar soluciones rápidas y confiables en productos de primera necesidad mediante compra online eficiente.",
    "Hoy la empresa se ha reinventado y enfocado estratégicamente en la prestación de servicios integrales en la región, manteniendo siempre su compromiso con la calidad y la satisfacción del cliente.",
    "Contamos con experiencia en proyectos informáticos, servicios eléctricos, traslados, aseo industrial y suministro de productos, trabajando bajo estándares profesionales y excelencia operativa."
  ]
};

export const services = [
  {
    id: 1,
    title: "Aseo Industrial",
    description: "Limpieza profunda de oficinas, post obra y mantención de espacios industriales con equipos especializados y personal capacitado.",
    icon: "Droplets",
    image: "https://images.pexels.com/photos/4767875/pexels-photo-4767875.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    features: [
      "Limpieza de oficinas",
      "Limpieza post obra",
      "Mantención de espacios industriales",
      "Personal especializado"
    ]
  },
  {
    id: 2,
    title: "Transporte de Carga",
    description: "Servicios de traslados, mudanzas y transporte de mercancías por carretera con vehículos modernos y conductores experimentados.",
    icon: "Truck",
    image: "https://images.pexels.com/photos/906484/pexels-photo-906484.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    features: [
      "Mudanzas residenciales y comerciales",
      "Traslado de mobiliario",
      "Transporte por carretera",
      "Logística especializada"
    ]
  },
  {
    id: 3,
    title: "Obras Civiles",
    description: "Ejecución de proyectos de construcción, remodelaciones y mantenciones con profesionales calificados y materiales de primera calidad.",
    icon: "HardHat",
    image: "https://images.pexels.com/photos/4956920/pexels-photo-4956920.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    features: [
      "Proyectos de construcción",
      "Remodelaciones",
      "Mantenciones preventivas",
      "Soluciones especializadas"
    ]
  },
  {
    id: 4,
    title: "Proyectos Informáticos",
    description: "Instalación de redes, cableado estructurado, soporte técnico y gestión integral de infraestructura TI para empresas.",
    icon: "Monitor",
    image: "https://images.pexels.com/photos/4389462/pexels-photo-4389462.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    features: [
      "Instalación de redes",
      "Cableado estructurado",
      "Soporte técnico TI",
      "Gestión de infraestructura"
    ]
  }
];

export const heroImage = "https://images.pexels.com/photos/5583996/pexels-photo-5583996.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

// Mock function for form submission (frontend only)
export const submitContactForm = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Mock form submission:", formData);
      resolve({
        success: true,
        message: "¡Gracias por tu mensaje! Te contactaremos pronto."
      });
    }, 1500);
  });
};
